import { http } from './http';

export function getToken() {
    return http.post('/telegram/token');
}

export function isTelegramConfirmed() {
    return http.post('/telegram/isConfirmed');
}